import { render, staticRenderFns } from "./BatchSetup.vue?vue&type=template&id=53f5bda4"
import script from "./BatchSetup.vue?vue&type=script&lang=ts"
export * from "./BatchSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports